import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { ApiResponse } from '../../../../definitions/apis/api-operation';
import { ApiResponsesService } from '../services/api-resopnses.service';

export const apiResponseResolver: ResolveFn<ApiResponse> = (
	route: ActivatedRouteSnapshot
): Observable<ApiResponse> => {
	const dataSvc = inject(ApiResponsesService);
	const responseId = route.paramMap.get('responseId');

	return responseId
		? dataSvc.find(responseId).pipe(catchError(() => of(null)))
		: of(null);
};
